import classes from './VersionTag.module.css';

export type UpdateState = 'none' | 'downloading' | 'ready';

export interface VersionTagProps {
  productName: string;
  version: string;
  /** Gemi uygulamasında güncelleme durumu; web ofiste her zaman `none`. */
  update?: UpdateState;
  /** Durum metinleri (çevrilmiş), ör. "Restart to update to 0.2.0". */
  labels?: { downloading: string; ready: string };
  /**
   * Güncelleme hazırken tıklanınca. Kurmaz: güncelleme bildirimini açar, kurulum orada onaylanır
   * (M6f G6-10).
   */
  onSelect?: () => void;
  compact?: boolean;
}

/**
 * Sol menünün altındaki ürün adı ve sürüm (NR496 [4.1.2]; docs/ekranlar/README.md "Sürüm alanı").
 * Yeni sürüm hazırsa alan düğmeye döner: üstte "Restart to update to x.y.z", altta kurulu sürüm.
 */
export function VersionTag({
  productName,
  version,
  update = 'none',
  labels,
  onSelect,
  compact = false,
}: VersionTagProps) {
  const text = `${productName} ${version}`;
  if (update === 'ready' && onSelect) {
    return (
      <button
        type="button"
        className={classes.root}
        data-state="ready"
        data-compact={compact || undefined}
        title={compact ? labels?.ready : undefined}
        aria-label={compact ? labels?.ready : undefined}
        onClick={onSelect}
      >
        <span className={classes.dot} aria-hidden />
        <span className={classes.texts}>
          <span className={classes.status}>{labels?.ready}</span>
          {compact ? null : <span className={classes.version}>{text}</span>}
        </span>
      </button>
    );
  }
  return (
    <div
      className={classes.root}
      data-state={update}
      data-compact={compact || undefined}
      title={text}
    >
      {update === 'downloading' ? <span className={classes.dot} data-pulse aria-hidden /> : null}
      <span className={classes.texts}>
        {update === 'downloading' && !compact ? (
          <span className={classes.status}>{labels?.downloading}</span>
        ) : null}
        <span className={classes.version}>{compact ? version : text}</span>
      </span>
    </div>
  );
}
